<!-- 顶层固定菜单栏 -->
<template>
  <div class="fixed-menu">
    <div class="menu-left">
      <div class="show-aside-box cursor-pointer" @mouseover="hoverImg" @mouseout="outHoverImg" @click="changeShowAside" v-show="!single_page">
        <img class="menu-icon" :src="showAsideImg"/>
      </div>
      <div class="menu-item">
        <span class="tab-link title">{{indexName}}</span>
      </div>
      <div @click="checkOutMenu(item.mid)" class="menu-item cursor-pointer hover-deep" v-for="(item, index) in menuData" :class="currentMidC===item.mid?'choose_active':''" :key="index">
        <span class="tab-link">{{item.menu_name}}</span>
      </div>
    </div>
    <div class="menu-right">
      <div class="search-item cursor-pointer" v-show="showSearch">
        <search-tool @getSearchData="getSearchData"></search-tool>
      </div>
      <div class="welcome-item">欢迎您，{{name}}</div>
      <div class="sigout-item-box cursor-pointer hover-deep" @click="signOut">
        <img class="menu-icon" src="~assets/icon/signout@2x.png"/>
      </div>
    </div>
  </div>
</template>
<script>
import AppConfig from '@/config'
import searchTool from 'components/searchReport'
import Cookies from 'js-cookie'

export default {
  data () {
    return {
      filelibUrl: AppConfig.filelibUrl,
      reportUrl: AppConfig.reportUrl,
      searchData: ''
    }
  },
  props: {
    menuTitle:{
      type:String
    },
    single_page:{
      type:Boolean,
      default:false
    },
    showAside: {
      type: Boolean,
      default: true
    },
    showAsideImg: {
      type: String
    },
    currentMidC: {
      type: Number
    },
    menuData: {
      type: Array,
      default: () => []
    },
    indexName: {
      type: String,
      default: '大数据蓝数通'
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: ''
    }
  },
  methods: {
    changeShowAside () {
      this.$emit('changeShowAside', !this.showAside, 'click')
    },
    hoverImg () {
      this.$emit('changeShowAside', this.showAside, 'hover')
    },
    outHoverImg () {
      this.$emit('changeShowAside', this.showAside, 'outHover')
    },
    checkOutMenu (id) {
      this.$emit('update:currentMidC', id)
    },
    signOut () {
      this.$emit('logout')
    },
    getSearchData (searchData) {
      this.searchData = searchData
      this.$emit('getSearchData', this.searchData)
    }
  },
  components: {
    searchTool
  }
}
</script>
<style lang="less">
@import "~assets/style/variable";
@import "~assets/style/mixin";
.fixed-menu {
  background: @color-theme;
  width: 100%;
  height: 100%;
  color: @color-text;
  font-size: @font-size-medium;
  word-break:keep-all;
  .flex-space-between;
  .title {
      display: inline-block;
      width:104px;
  }
  .menu-left, .menu-right {
    height: 100%;
    .flex-center;
    .menu-item {
        padding: 0 20px;
    }
    .search-item {
        width: 190px;
        height: 100%;
    }
    .welcome-item {
        height: 100%;
        padding: 0 23px;
        min-width: 100px;
    }
  }
}
.show-aside-box {
  .choose_active;
}
.sigout-item-box, .show-aside-box  {
  width: 56px;
  height: 100%;
  .flex-center;
  .menu-icon {
    width: 44px;
    height: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixedMenu.vue